getObsQueryOptions